import styled from 'styled-components';
import { Combinator } from 'modules/queryBuilder/types';
import { body2Bold, colors, spacing, shadows } from 'ui/theme';
import { actionButtonGroupRadii } from '../QueryLayout/QueryLayout.styles';

export const CriteriaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: ${spacing.single} solid ${colors.borderPrimarySubtle};
  border-radius: ${spacing.quarter};
  box-shadow: ${shadows.subtle.join(',')};
  background: white;
`;

export const CriteriaHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing.base};
  border: 0 0 0 ${spacing.eighth};
`;

export const CombinatorWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${spacing.half};
`;

export const CombinatorIconWrapper = styled.div`
  position: absolute;
  left: -${spacing.half};
  top: ${spacing.plusQuarter};
  svg {
    background-color: ${colors.backgroundPrimary};
  }
`;

export const TextWrapper = styled.span`
  ${body2Bold};
`;

export const RequirementWrapper = styled.div`
  &[data-combinator=${Combinator.AND}] {
    border-left: ${spacing.eighth} solid ${colors.brandGreen};
    margin-left: -${spacing.single};
  }
  &[data-combinator=${Combinator.OR}] {
    border-left: ${spacing.eighth} solid ${colors.brandCyan};
    margin-left: -${spacing.single};
  }
  &[data-combinator=${Combinator.NOT}] {
    border-left: ${spacing.eighth} solid ${colors.brandRed};
    margin-left: -${spacing.single};
  }
`;

export const RequirementsWrapper = styled.div`
  border-top: ${spacing.single} solid ${colors.borderPrimarySubtle};
  border-bottom: ${spacing.single} solid ${colors.borderPrimarySubtle};
  display: flex;
  flex-direction: column;
`;

export const RequirementWithCombinatorWrapper = styled.div`
  padding: ${spacing.quarter} 0;  
  position: relative;
  &:not(:last-child)::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: ${spacing.single};
    background-color: ${colors.borderPrimarySubtle};
  }
`;

export const CriteriaFooter = styled.div`
  display: flex;
  align-items: center;
  padding: ${spacing.base};
  gap: ${spacing.half};
`;

export const ActionButtonWrapper = styled.div`
  display: flex;
  ${actionButtonGroupRadii('>')};
`;
